import React from 'react';

import { AttentionCircleFilledIcon, SettingsIcon } from '@vlabs/icons';
import { Control, Badge } from '@vlabs/uikit';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CustomFilterPopover } from '../components/CustomFilterPopover';
import { hasAnyError } from '../helpers';
import shared from '../shared.module.sass';
import st from './ScoreFieldsPopover.module.sass';

export function ScoreFieldsPopover({ scoreFields, disabled, ...props }) {
  const { t } = useTranslation();
  const { register, setValue, formState: { errors } } = useFormContext();

  const [gte, lt] = useWatch({ name: [scoreFields?.gte, scoreFields?.lt] }) || [];
  const filterCount = [gte, lt].filter(Boolean).length;

  if (!scoreFields) return null;

  const handleReset = () => {
    setValue(scoreFields.gte, '');
    setValue(scoreFields.lt, '');
  };
  return (
    <CustomFilterPopover
      className={st.ScorePopoverInLeft}
      disabled={disabled}
      hasError={
        hasAnyError(errors, scoreFields.gte)
        || hasAnyError(errors, scoreFields.lt)
      }
      hasFilterValue={filterCount > 0}
      testId="ScoreFieldsPopover"
      triggerNode={(
        <div className={st.ScoreTrigger}>
          <Control.IconButton
            data-testid='ScoreFieldButton'
            disabled={disabled}
            icon={<SettingsIcon />}
            kind="secondary"
            shape="round"
            variant="dimmed"
          />
          {filterCount > 0 && (
          <Badge
            className={st.ScoreBadge}
            kind="secondary"
            value={filterCount}
          />
          )}
        </div>
      )}
      {...props}
    >
      <label className="Input__Label">{t(scoreFields.labelKey)}</label>

      <div className={shared.flex}>
        <div className={shared.DoubleInputs}>
          <Control.Input
            id={scoreFields.gte}
            placeholder={t('от')}
            {...register(scoreFields.gte, scoreFields.validationRules)}
            errors={errors}
            isClearable
            onClear={() => setValue(scoreFields.gte, '')}
          />
        </div>
        <div className={shared.DoubleInputs__Divider}>:</div>
        <div className={shared.DoubleInputs}>
          <Control.Input
            id={scoreFields.lt}
            placeholder={t('до')}
            {...register(scoreFields.lt, scoreFields.validationRules)}
            errors={errors}
            isClearable
            onClear={() => setValue(scoreFields.lt, '')}
          />
        </div>
      </div>
      <div className={st.ScoreInfo}>
        <div><AttentionCircleFilledIcon className={st.ScoreInfo__Icon} /></div>
        <div>{t('videoAnalytics:archivePage.filters.score.infoBlock')}</div>
      </div>
      <div className={shared.Divider} />
      <Control.Button
        disabled={filterCount === 0}
        kind="negative"
        onClick={handleReset}
        size="small"
        variant="filled"
      >
        {t('button.clear')}
      </Control.Button>
    </CustomFilterPopover>
  );
}
